import React from "react";
import Caraousel from "./caraousel";

export default function BeyondWork() {
    const assets = {
        videos: {
            roadTrips: "https://res.cloudinary.com/dwf2vdotu/video/upload/v1706223931/mpack8eyl2lg5a3zp3t9.mp4",
            videoEditing: "https://res.cloudinary.com/dwf2vdotu/video/upload/v1706223933/vm3n2zndjxwit7rmce2o.mp4"
        },
        images: {
            blender: [
                "https://res.cloudinary.com/dwf2vdotu/image/upload/v1706224436/hobbies/blender/vuqlv9xyuipbil1t3o5g.png",
                "https://res.cloudinary.com/dwf2vdotu/image/upload/v1706224436/hobbies/blender/sktti6vuilsvjo1lgkjj.jpg",
                "https://res.cloudinary.com/dwf2vdotu/image/upload/v1706224436/hobbies/blender/aisz9tjdbx91mcx8vnk6.jpg"
            ],
            photography: [
                "https://res.cloudinary.com/dwf2vdotu/image/upload/v1706224305/hobbies/photography/ptgtttncr5goyu6px96k.jpg",
                "https://res.cloudinary.com/dwf2vdotu/image/upload/v1706224305/hobbies/photography/pxnmgvdl4x4gfwmbzcmh.jpg",
                "https://res.cloudinary.com/dwf2vdotu/image/upload/v1706224305/hobbies/photography/y8pwbkstfgg7aqms3zpe.jpg",
                "https://res.cloudinary.com/dwf2vdotu/image/upload/v1706224305/hobbies/photography/v9wsf9nhfcyivsdpec2w.jpg",
                "https://res.cloudinary.com/dwf2vdotu/image/upload/v1706224305/hobbies/photography/w333c9a6rraoujvg3jno.jpg"
            ],
            creativeDesign: [
                "https://res.cloudinary.com/dwf2vdotu/image/upload/v1706224484/hobbies/photoshop/xsw5qsnuoqceyrykksw7.jpg",
                "https://res.cloudinary.com/dwf2vdotu/image/upload/v1706224484/hobbies/photoshop/zehsvck4dbgr8ped7fvg.jpg",
                "https://res.cloudinary.com/dwf2vdotu/image/upload/v1706224484/hobbies/photoshop/euydghwghi4d7najmgvs.jpg",
                "https://res.cloudinary.com/dwf2vdotu/image/upload/v1706224484/hobbies/photoshop/dnjz8owquan5wixjijiu.jpg",
                "https://res.cloudinary.com/dwf2vdotu/image/upload/v1706224484/hobbies/photoshop/y8ctkymmaggjet3p17uz.jpg"
            ]
        }
    };

    return (
        <div className="hobbies-container">
            <div className="hobbie-circle-container1">
                <div className="hobbie-circle">
                    <div className="hobbie-title">3D Art & Modeling</div>
                    <Caraousel image1={assets.images.blender[0]} image2={assets.images.blender[1]} image3={assets.images.blender[2]} />
                </div>
                <div className="hobbie-circle">
                    <div className="hobbie-title">Through the Lens
                    </div>
                    <Caraousel 
                        image1={assets.images.photography[0]} 
                        image2={assets.images.photography[1]} 
                        image3={assets.images.photography[2]} 
                        image4={assets.images.photography[3]} 
                        image5={assets.images.photography[4]} 
                    />
                </div>
                <div className="hobbie-circle">
                    <div className="hobbie-title">Adventures & Road Trips</div>
                    <video controls={false} width="100%" autoPlay loop muted className="Video1">
                        <source src={assets.videos.roadTrips} type="video/mp4" />
                    </video>
                </div>
            </div> 
            <div className="hobbie-circle-container2">
                <div className="hobbie-circle">
                    <div className="hobbie-title">Cinematic Storytelling</div>
                    <video controls={false} width="100%" autoPlay loop muted className="Video">
                        <source src={assets.videos.videoEditing} type="video/mp4" />
                    </video>
                </div>  
                <div className="hobbie-circle">
                    <div className="hobbie-title">Creative Design</div>
                    <Caraousel 
                        image1={assets.images.creativeDesign[0]} 
                        image2={assets.images.creativeDesign[1]} 
                        image3={assets.images.creativeDesign[2]} 
                        image4={assets.images.creativeDesign[3]} 
                        image5={assets.images.creativeDesign[4]} 
                    />
                </div>                  
            </div>
        </div>
    );
}
